import { render, staticRenderFns } from "./templateEditor.vue?vue&type=template&id=16940858&scoped=true"
import script from "./templateEditor.vue?vue&type=script&lang=js"
export * from "./templateEditor.vue?vue&type=script&lang=js"
import style0 from "./templateEditor.vue?vue&type=style&index=0&id=16940858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16940858",
  null
  
)

export default component.exports